import { useEffect } from "react";

import {
  useGetProfile,
  useIsProfileContextMutating,
  useUpdateProfileContext,
} from "@/entities/profile";
import {
  useOrganizationContext,
  useOrganizationContextInvalid,
} from "@/modules/organization/organization-context";

export const useOrganizationContextSync = () => {
  const { contextSlug } = useOrganizationContext();
  const { isInvalid, isLoading } = useOrganizationContextInvalid();

  const { profile, isFetching } = useGetProfile();
  const { mutate, isPending } = useUpdateProfileContext();
  const isMutating = useIsProfileContextMutating();

  const profileValue = profile?.context;
  const isNotDefined = !contextSlug || !profileValue || isInvalid;
  const isProcessing = isFetching || isLoading || isPending || isMutating;

  // Save context value in user profile when url param `context` update.
  // Do not update when same mutation is already running or data is fetching.
  useEffect(() => {
    if (isProcessing || isNotDefined || contextSlug === profileValue) return;
    mutate(contextSlug);
  }, [contextSlug, profileValue, isNotDefined, isProcessing, mutate]);
};
